import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // d// defaults to localStorage for web
import authSlice from "./reducers/authSlice";
import errorReducer from "./reducers/Error";
import messageReducer from "./reducers/Message";
import accountSlice from "./reducers/accountSlice";
import accountMetricsSlice from "./reducers/accountMetricsSlice";
import competitionSlice from "./reducers/competitionSlice";
import infoReducer from "./reducers/Info";

const persistConfig = {
  key: "acg-futures-root",
  storage,
};

// Combine all reducers into a single reducer
const rootReducer = combineReducers({
  auth: authSlice,
  message: messageReducer,
  error: errorReducer,
  info: infoReducer,
  accountList: accountSlice,
  accountMetrics: accountMetricsSlice,
  competitionList: competitionSlice
});

// Apply persistReducer to the combined reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export const clearPersistedData = async () => {
  await persistor.purge();
};

export default store;
